import React, { useRef, useEffect, useState } from 'react'
import './ImageLoader.scss'
import LoadingDots from '../LoadingDots/LoadingDots'

const ImageLoader = ({ className, src, onImageLoad, scrollableRef, loadingDots }) => {
  const [show, setShow] = useState(false)
  const [imageLoaded, setImageLoaded] = useState(true)
  const containerRef = useRef(null)
  const timeoutHandler = useRef(0)

  useEffect(() => {
    if (!scrollableRef?.current) return
    const options = {
      root: scrollableRef.current,
      rootMargin: '0px',
      threshold: 0.01,
    }

    let callback = (entries, observer) => {
      entries.forEach((entry) => {
        if ((scrollableRef.current === document.body && !entry.isIntersecting) ||
          entry.isIntersecting) {
          setShow(true)
          observer.disconnect()
          if (!timeoutHandler.current) {
            timeoutHandler.current = setTimeout(() => setImageLoaded(false), 400)
          }
        }

      })
    }
    let observer = new IntersectionObserver(callback, options)
    observer.observe(containerRef.current)
  }, [scrollableRef])

  const onImageLoadHandler = (e) => {
    clearTimeout(timeoutHandler.current)
    setImageLoaded(true)
    onImageLoad && onImageLoad(e)
  }

  return (
    <div className={`xmp-gs-image-loader ${className ? className : ''}`} ref={containerRef}>
      {!imageLoaded && <>{loadingDots ? <LoadingDots/> : <div className="animated loading"/>}</>}
      {show && <img
        alt=""
        src={src}
        onLoad={onImageLoadHandler}
        className={imageLoaded ? 'loaded' : ''}
      />}
    </div>
  )
}

export default ImageLoader
